var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { "min-width": "500px" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 pb-3" },
            [
              _c("v-card-text", { staticClass: "blue--text" }, [
                _vm._v(
                  _vm._s(
                    _vm.deployedPackage == null ? "" : _vm.deployedPackage.name
                  )
                ),
              ]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 pa-0",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-3" },
            [
              _c("v-autocomplete", {
                attrs: {
                  dense: "",
                  items: _vm.audiences,
                  outlined: "",
                  "item-text": "name",
                  "item-value": "name",
                  "return-object": "",
                  "small-chips": "",
                  multiple: "",
                  "deletable-chips": "",
                  label: "Audiences",
                },
                model: {
                  value: _vm.aud,
                  callback: function ($$v) {
                    _vm.aud = $$v
                  },
                  expression: "aud",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mt-7 pb-3", attrs: { dense: "" } },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: {
                    loading: _vm.working,
                    elevation: "0",
                    color: "primary",
                  },
                  on: { click: _vm.onPressActivate },
                },
                [_vm._v("SAVE ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }